//@ts-nocheck
import * as React from 'react';
import renderHTML from 'react-render-html';

class UniversityList extends React.Component<Props, {}> {

    render() {
        const { description, university } = this.props;
        return (<div className="col-md-12" style={{ paddingTop: "20px" }}>
                {(university == "CPUPC Universities" || university == "CPUPC/IRIS Universities") &&
                    <span>The universities included in this report, which are members of the Council of Public University Presidents and Chancellors and IRIS, are: {description}</span>
                }
                {university == "IRIS Universities" &&
                    <span>The universities included in this report, which are members of IRIS, are: {description}</span>
                }
            </div>
        )
    };
}

export default UniversityList;